<script lang="ts">
import { navigate, useLocation, useParams } from "svelte-navigator";
import { Alert, Button, Col, FormGroup, Input, Modal, Row } from "sveltestrap";
import Credentials from "../components/Credentials.svelte";
import { authService, uiService } from "../services";
import { startSession, isLoggedIn, endSession, accessToken } from "../services/session";
import { GoogleAuth, FacebookAuth } from '@beyonk/svelte-social-auth';
import { dateEnd, dateStart } from "../evironment";
import { dematerialize } from "rxjs";
import { onMount } from "svelte";

    let showLoginError = false;
    let showLegalError = false
    let acceptLegalText = false;
    let open = false;
    let viewResults = false;

    const params = useParams();

    const location = useLocation();
    const toggle = () => (open = !open);
    const dateNow = new Date();
    
    onMount(() => {

        if ($params.qwerty == 'qwerty') {
            viewResults = true
        }

        if ($params.alias) {
            sessionStorage.setItem('voteId', $params.alias)
        }else{
            const paramsUrl = new URLSearchParams($location.search);

            sessionStorage.setItem('voteId', null)
            if(paramsUrl.has('vote')){
                sessionStorage.setItem('voteId', paramsUrl.get('vote'))
            }
        }
    })
    

    if (isLoggedIn()) {
        endSession()
    }

    async function login(name, email) {
        const accessToken = await authService.login(name, email);   
        await startSession(accessToken);

        if ($params.qwerty == 'qwerty') {
            navigate('/qwerty');
        }else{
            navigate('/');
        }

    }

    function onFacebookAuthSuccess(event){

        if (!acceptLegalText) {
            showLegalError = true;
            return;
        }

        if (event.detail && event.detail.accessToken) {
            window.FB.api('/me?fields=id,name,email', function(response) {
                login(response.name, response.email) 
            });
        }
    }

    function onGoogleAuthSuccess(event){

        if (!acceptLegalText) {
            showLegalError = true;
            return;
        }
        
        if (event.returnValue) {
            if (event.returnValue) {
                login(event.detail.user.Ju.tf, event.detail.user.Ju.zv) 
            }  
        }
    }

    function onPhantomClick(){
        
    }

</script>



<style lang="scss">

    .body-html {
        position: relative;
        min-height: 100vh;
        display: flex;
        align-items: center;
        padding-bottom: 40px;
        max-width: 360px;
        margin: auto;
        justify-content: center;
    }


    :global(.modal-content){
        background-color: #CF2F2C !important;
        border-radius: 2rem !important;
        border: 2px solid white !important;
        margin: 0 15px 0 15px !important;
        padding: 15px !important;

        :global(button){
            background-color: #CF2F2C !important; 
            border: 2px solid white !important;
        }
    }

    img{
        height: auto;
        width: 100%;
        padding: 0px;
    }

    hr{
        color: #FFFFFF;
        max-width: 242px;
        margin: auto;
        opacity: 1;
        margin-bottom: 20px;
        margin-top: 20px;
        height: 1px;
    }
    .text-vote{
        margin-top: 10px;
        margin-left: 10px;
    }

    .vote-info{
        max-width: 300px;
        margin: auto;
    }

    .form-floating{
        width: 100%;
        max-width: 275px;
        margin: auto;
        position: relative;

        &.disabled{
            filter: grayscale(1);
            opacity: 0.3;
        }

        .phantom{
            position: absolute;
            z-index: 2;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
        }

        :global(button){
            font-family: 'Lato', sans-serif !important;
            min-height: 50px;
            border-radius: 5px !important;
            font-weight: bold !important;
        }
        :global(span){
            display: none;
        }
        :global(.facebook-auth){
            margin-top: 20px;
            background-color: #3B5998 !important;
            
            :global(img){
                display: none;
            }

            &::after{
                content: 'Votar con Facebook';
                color: white !important;
                margin-left: 5px;
            }
        }

        :global(.google-auth){
            background-color: #CF2F2C !important;
            :global(img){
                display: none;
            }

            &::after{
                content: 'Votar con Gmail';
                color: white !important;
                margin-left: 5px;
            }
        }
    }

    .form-link{
        width: 100%;
        max-width: 275px;
        margin: 0 auto;
        margin-top: 20px;
        :global(.btn-link){
            font-family: 'Lato', sans-serif !important;
            color: #CF2F2C;
            font-size: 14px;
            padding: 0px;
            text-align: start !important;
            text-decoration: none;
            font-weight: 400 !important;
        }
    }

    .box-logo{
        position: relative;
        margin-top: 10px;

        img{
            width: 75%;
        }
    }




</style>

<div class="body-html">
    <div class="row text-center">
        
        <div class="col-12 p-0">
            <img src="/img/EnmascaraPortada.jpg" alt="">
        </div>
        <div class="col-12 text-vote">
            <h1 class="mb-3 font-tittle">¡Tú eliges el mejor destino!</h1>

            <div class="vote-info text-center">
                <div class="mb-3">
                    <span class="second-tittle">Encuesta abierta del <strong>26 de febrero al 5 de marzo</strong> de 2022</span>
                </div>
                
            
                {#if (dateNow > dateStart && dateNow < dateEnd) || viewResults}
                
                    <div class="form-floating" class:disabled={!acceptLegalText}> 
                        {#if !acceptLegalText}
                            <div class="phantom" on:click={toggle}></div>
                        {/if}
                        <GoogleAuth clientId="764442144253-q9rjj70mdcmvbjdcto4h6djme7gqsaep.apps.googleusercontent.com" on:auth-success={onGoogleAuthSuccess} />
                        <FacebookAuth appId="6986793604695051" on:auth-success={onFacebookAuthSuccess}/>
                    </div>
    
                    <div class="form-link">
                        <Row>
                            <Col xs="1">        
                                <FormGroup>
                                    <Input id="c1" type="checkbox" bind:checked={acceptLegalText}/>
                                </FormGroup>
                            </Col>
                            <Col xs="11" class="text-start">
                                <Button color="link" on:click={toggle}>Acepto las condiciones de privacidad</Button>
                            </Col>
                          </Row>
                
                    </div>
    
    
                    {#if showLoginError}
                        <Alert>
                            Ha ocurrido un error
                        </Alert>
                    {/if}
    
                    {#if showLegalError && !acceptLegalText}
                        <Alert>
                            Debe aceptar las condiciones legales, para poder acceder a la votación
                        </Alert>
                    {/if}
                {:else if dateNow < dateStart}  
                    <span class="third-tittle mt-3"><br>La votación comenzará en breve.</span>
    
                {:else if dateNow > dateEnd}
                    <span class="third-tittle mt-3"><br>La votación ha concluido, muchas gracias por la participación.</span>
                {/if}


                <div class="col-12 p-0 mt-3">
                    <div class="box-logo">
                        <img src="/img/LaOrotava.png" alt="">
                    </div>
                </div>

            </div>
     
        </div>
        <p class="mt-2 mb-3 text-muted"><Credentials /></p>
    </div>


    <Modal class="modal-dialog-centered modal-dialog-scrollable" body header="" isOpen={open} {toggle} >
        <Col>
            <div class="third-tittle">
                <span><strong>Texto Legal</strong></span> 
                <br><br>
                <span>Conforme a lo previsto en la Ley Orgánica 15/99 de 13 de diciembre, de protección de datos de carácter personal, ponemos en conocimiento que los datos extraídos de esta aplicación serán destinados única y exclusivamente para la finalidad objeto de la misma, formando parte de un fichero informático cuyo responsable es el Ayuntamiento de La Orotava, a quien podrá dirigirse para hacer uso de los derechos que le confiere la mencionada Ley Orgánica.</span>
            </div>
         </Col>
        <Col class="text-center mt-4">
            <div class="d-grid gap-2">
                <Button color="danger" on:click={() => {
                    open = false;
                    acceptLegalText = true;
                }}> <span class="third-tittle"><strong>Aceptar</strong></span>
                </Button>
            </div>
        </Col>
    </Modal>
</div>
